!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactRecaptcha = t(require("react")) : e.ReactRecaptcha = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (a[r]) return a[r].exports;
      var n = a[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports;
    }

    var a = {};
    return t.m = e, t.c = a, t.p = "", t(0);
  }([function (e, t, a) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var l = function () {
      function e(e, t) {
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, a, r) {
        return a && e(t.prototype, a), r && e(t, r), t;
      };
    }(),
        s = a(6),
        c = r(s),
        p = a(4),
        u = r(p),
        d = {
      className: u.default.string,
      onloadCallbackName: u.default.string,
      elementID: u.default.string,
      onloadCallback: u.default.func,
      verifyCallback: u.default.func,
      expiredCallback: u.default.func,
      render: u.default.oneOf(["onload", "explicit"]),
      sitekey: u.default.string,
      theme: u.default.oneOf(["light", "dark"]),
      type: u.default.string,
      verifyCallbackName: u.default.string,
      expiredCallbackName: u.default.string,
      size: u.default.oneOf(["invisible", "compact", "normal"]),
      tabindex: u.default.string,
      hl: u.default.string,
      badge: u.default.oneOf(["bottomright", "bottomleft", "inline"])
    },
        f = {
      elementID: "g-recaptcha",
      className: "g-recaptcha",
      onloadCallback: void 0,
      onloadCallbackName: "onloadCallback",
      verifyCallback: void 0,
      verifyCallbackName: "verifyCallback",
      expiredCallback: void 0,
      expiredCallbackName: "expiredCallback",
      render: "onload",
      theme: "light",
      type: "image",
      size: "normal",
      tabindex: "0",
      hl: "en",
      badge: "bottomright"
    },
        h = function h() {
      return "undefined" != typeof window && "undefined" != typeof window.grecaptcha && "function" == typeof window.grecaptcha.render;
    },
        y = void 0,
        b = function (e) {
      function t(e) {
        n(this, t);
        var a = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return a._renderGrecaptcha = a._renderGrecaptcha.bind(a), a.reset = a.reset.bind(a), a.state = {
          ready: h(),
          widget: null
        }, a.state.ready || "undefined" == typeof window || (y = setInterval(a._updateReadyState.bind(a), 1e3)), a;
      }

      return i(t, e), l(t, [{
        key: "componentDidMount",
        value: function value() {
          this.state.ready && this._renderGrecaptcha();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t) {
          var a = this.props,
              r = a.render,
              n = a.onloadCallback;
          "explicit" === r && n && this.state.ready && !t.ready && this._renderGrecaptcha();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          clearInterval(y);
        }
      }, {
        key: "reset",
        value: function value() {
          var e = this.state,
              t = e.ready,
              a = e.widget;
          t && null !== a && grecaptcha.reset(a);
        }
      }, {
        key: "execute",
        value: function value() {
          var e = this.state,
              t = e.ready,
              a = e.widget;
          t && null !== a && grecaptcha.execute(a);
        }
      }, {
        key: "_updateReadyState",
        value: function value() {
          h() && (this.setState({
            ready: !0
          }), clearInterval(y));
        }
      }, {
        key: "_renderGrecaptcha",
        value: function value() {
          this.state.widget = grecaptcha.render(this.props.elementID, {
            sitekey: this.props.sitekey,
            callback: this.props.verifyCallback ? this.props.verifyCallback : void 0,
            theme: this.props.theme,
            type: this.props.type,
            size: this.props.size,
            tabindex: this.props.tabindex,
            hl: this.props.hl,
            badge: this.props.badge,
            "expired-callback": this.props.expiredCallback ? this.props.expiredCallback : void 0
          }), this.props.onloadCallback && this.props.onloadCallback();
        }
      }, {
        key: "render",
        value: function value() {
          return "explicit" === this.props.render && this.props.onloadCallback ? c.default.createElement("div", {
            id: this.props.elementID,
            "data-onloadcallbackname": this.props.onloadCallbackName,
            "data-verifycallbackname": this.props.verifyCallbackName
          }) : c.default.createElement("div", {
            id: this.props.elementID,
            className: this.props.className,
            "data-sitekey": this.props.sitekey,
            "data-theme": this.props.theme,
            "data-type": this.props.type,
            "data-size": this.props.size,
            "data-badge": this.props.badge,
            "data-tabindex": this.props.tabindex
          });
        }
      }]), t;
    }(s.Component);

    t.default = b, b.propTypes = d, b.defaultProps = f, e.exports = t.default;
  }, function (e, t) {
    "use strict";

    function a(e) {
      return function () {
        return e;
      };
    }

    var r = function r() {};

    r.thatReturns = a, r.thatReturnsFalse = a(!1), r.thatReturnsTrue = a(!0), r.thatReturnsNull = a(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = r;
  }, function (e, t, a) {
    "use strict";

    function r(e, t, a, r, o, i, l, s) {
      if (n(t), !e) {
        var c;
        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var p = [a, r, o, i, l, s],
              u = 0;
          c = new Error(t.replace(/%s/g, function () {
            return p[u++];
          })), c.name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    }

    var n = function n(e) {};

    e.exports = r;
  }, function (e, t, a) {
    "use strict";

    var r = a(1),
        n = a(2),
        o = a(5);

    e.exports = function () {
      function e(e, t, a, r, i, l) {
        l !== o && n(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var a = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t
      };
      return a.checkPropTypes = r, a.PropTypes = a, a;
    };
  }, function (e, t, a) {
    e.exports = a(3)();
  }, function (e, t) {
    "use strict";

    var a = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    e.exports = a;
  }, function (t, a) {
    t.exports = e;
  }]);
});